"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetItShine() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="130922" id="der-erste-schritt" className="bg-background text-foreground py-24 sm:py-32 px-4 sm:px-6 lg:px-8 overflow-hidden font-sans font-light">
      <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="bg-gradient-to-br from-secondary to-muted text-foreground border border-primary/10 rounded-3xl p-10 sm:p-16 md:p-24 text-center shadow-xl shadow-primary/5 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-2 bg-primary" />

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-light mb-10 tracking-wider">
            Der erste Schritt zur <span className="heading-italic">Klarheit</span>
          </h2>

          <Button size="lg" asChild className="text-base sm:text-lg h-auto px-8 py-4 rounded-full shadow-md hover:shadow-lg transition-all hover:-translate-y-1 bg-primary text-primary-foreground">
            <Link to="mailto:post@claudiachrist.de">Kontakt aufnehmen</Link>
          </Button>
        </div>
      </div>
    </section>;
}